<template>
    <v-container>
        <v-layout>
            <v-flex>

                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    max-width="500px"
                    transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Agregar / Editar Item</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text v-if="itemTree!=''">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm7 offset-sm1>
                                    <v-text-field
                                            name="codigo"
                                            label="Código"
                                            id="code"
                                            :rules="[v => !!v || 'El código es requerido', v => (v && v.length <= 10)]"
                                            v-model="itemTree.code"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="nombre"
                                            label="Nombre"
                                            id="nombre"
                                            :rules="[v => !!v || 'Es requerido' ]"
                                            v-model="itemTree.name"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            id="trimesterId"
                                            multiple
                                            :items="itemsTrimestre"
                                            v-model="itemTree.trimester"
                                            label="Trimestre"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            id="mondsId"
                                            multiple
                                            :items="items"
                                            v-model="itemTree.months"
                                            label="Meses"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            id="frequencyId"
                                            :items="itemsFrecuencia"
                                            v-model="itemTree.frequency"
                                            label="Frecuencia"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-combobox
                                            id="questionsId"
                                            v-model="itemTree.questions"
                                            :items="questions"
                                            label="Preguntas actividad"
                                            multiple
                                            outlined
                                            dense
                                    ></v-combobox>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn :disabled="!valid"
                                               @click="saveData"
                                               large color="primary">Guardar
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <br>
      <v-treeview v-if="itemsTree!=[]"
                  :active.sync="active"
                  :items="itemsTree"
                  :load-children="getChildren"
                  :open.sync="open"
                  v-model="tree"
                  activatable
                  active-class="primary--text"
                  class="grey lighten-5"
                  open-on-click
                  :filter="filter"   >
            <template v-slot:label="{ item, active }">
                    <table style="width:100%">
                        <tr>
                            <th width="10%">
                                <v-text-field :readonly="!item.allowEdit"
                                              label="Código"
                                              v-model="item.code"
                                ></v-text-field>
                            </th>
                            <th width="70%">
                                <v-text-field :readonly="!item.allowEdit"
                                              label="Nombre"
                                              v-model="item.name"
                                ></v-text-field>
                            </th>
                            <th>
                                <v-tooltip top>
                                    <v-btn fab dark small @click="addItem(item)" slot="activator" color="primary">
                                        <v-icon dark>add</v-icon>
                                    </v-btn>
                                    <span>Añadir</span>
                                </v-tooltip>
                                <v-tooltip top  v-if="item.allowEdit">
                                    <v-btn fab dark small @click="editItem(item)" slot="activator" color="primary">
                                        <v-icon dark>edit</v-icon>
                                    </v-btn>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.allowEdit">
                                    <v-btn fab dark small @click="deleteItem(item)" slot="activator" color="primary">
                                        <v-icon dark>delete</v-icon>
                                    </v-btn>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </th>
                        </tr>
                    </table>
            </template>
        </v-treeview>
    </v-container>
</template>
<script>
    import Catalog from '../../model/Catalog';

    export default {

        data() {
            return {
                search: '',
                active: [],
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                headers: [
                    {text: 'Tipo', value: 'type'},
                    {text: 'Nombre', value: 'name'},
                    {text: 'ID', value: 'id'},
                    {text: 'Código', value: 'code'},
                    {text: 'Catálogo Padre', value: 'catalogueItemId'},
                    {text: 'Estado', value: 'estado'},
                    {text: 'Acciones', value: 'editar'},
                ],
                itemsTrimestre: ['Q1','Q2','Q3','Q4'],
                items: [1,2,3,4,5,6,7,8,9,10,11,12],
                itemsFrecuencia: ['4 POR MES','2 POR MES','1 POR MES','1 CADA 2 MESES', '1 POR TRIMESTRE', '1 POR SEMESTRE','1 POR AÑO' ,'A DEMANDA'],
                editedIndex: -1,
                catalog: new Catalog(),
                catalogParent: new Catalog(),
                open: [],
                nextId: 0,
                itemsTree:[],
                itemsTreeBu: [
                    {
                        code: 'CS', name: 'CONDICIONES DE SALUD', allowEdit:false,
                        children: [
                            {
                                code: "CS-KS", name: 'Cuidados de la salud', allowEdit:false,
                                children: [
                                    {
                                        code: "CS-KS-A", name: 'Promoción, prevención', allowEdit:false,
                                        children: [
                                            {
                                                code: "CS-KS-A1", name: 'Promoción de la salud', allowEdit:false,
                                                children: [
                                                    {
                                                        code: "CS-KS-A1.1", name: 'Manifestaciones Saludables', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A1.2", name: 'Estilos de vida Saludables', allowEdit:true
                                                    },
                                                ],
                                            },
                                            {
                                                code: "CS-KS-A2", name: 'Exámenes', allowEdit:false,
                                                children: [
                                                    {
                                                        code: "CS-KS-A2.1", name: 'Pre-ocupacional', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A2.2", name: 'Inicial', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A2.3", name: 'Periódico', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A2.4", name: 'Reubicación', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A2.5", name: 'Especial', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A2.6", name: 'Retiro', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A2.7", name: 'Reinserción', allowEdit:true
                                                    },
                                                ],
                                            },
                                            {
                                                code: "CS-KS-A3", name: 'Monitoreo Epidemiológico laboral', allowEdit:false,
                                                children: [
                                                    {
                                                        code: "CS-KS-A3.1", name: 'Cardio-vascular', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A3.2", name: 'Osteo-muscular', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A3.3", name: 'Dermátologico', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A3.4", name: 'Nutricional / Metabólico', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A3.5", name: 'Respiratorio', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A3.6", name: 'Auditivo', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A3.7", name: 'Salud Mental', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A3.8", name: 'Oftalmológico', allowEdit:true
                                                    },
                                                ],
                                            },
                                            {
                                                code: "CS-KS-A4", name: 'Selección / Contratación', allowEdit:false,
                                                children: [
                                                    {
                                                        code: "CS-KS-A4.1", name: 'Profesiogramas', allowEdit:true
                                                    },
                                                ],
                                            },
                                            {
                                                code: "CS-KS-A5", name: 'Capacitación, difusión y entrenamiento', allowEdit:false,
                                                children: [
                                                    {
                                                        code: "CS-KS-A5.1", name: 'Legislación', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.2", name: 'IPER', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.3", name: 'Higiene Laboral', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.4", name: 'Investigación Accidentes, incidentes y enfermedades del trabajo', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.5", name: 'Charlas informativas', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.6", name: 'Casas abiertas', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.7", name: 'Divulgación de precticas saludables', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.8", name: 'Educación Medica continua', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A5.9", name: 'Divulgación de actividades SME', allowEdit:true
                                                    },
                                                ],
                                            },
                                            {
                                                code: "CS-KS-A6", name: 'Protección específica', allowEdit:false,
                                                children: [
                                                    {
                                                        code: "CS-KS-A6.1", name: 'Vacunación', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A6.2", name: 'Seguridad alimentaria', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A6.3", name: 'Agua de consumo', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A6.4", name: 'Plagas y vectores', allowEdit:true
                                                    },
                                                    {
                                                        code: "CS-KS-A6.5", name: 'EPP', allowEdit:true
                                                    },
                                                ],
                                            },

                                        ],
                                    },
                                    {
                                        code: "CS-KS-B", name: 'Recuperación', allowEdit:false,
                                        children: [
                                            {
                                                code: "CS-KS-B1", name: 'Exámenes específicos', allowEdit:true
                                            },
                                            {
                                                code: "CS-KS-B2", name: 'Diagnóstico y tratamiento', allowEdit:true
                                            },

                                        ],
                                    },
                                    {
                                        code: "CS-KS-C", name: 'Rehabilitación de la salud en el trabajo', allowEdit:false,
                                        children: [
                                            {
                                                code: "CS-KS-C1", name: 'Física/Mental/Social: Enfermo/Accidentado', allowEdit:true
                                            },
                                            {
                                                code: "CS-KS-C2", name: 'Programa de reinserción laboral', allowEdit:true
                                            },

                                        ],
                                    },

                                ],
                            },
                            {
                                code: "CS-SME", name: 'Servicio médico de empresas', allowEdit:false,
                                children: [
                                    {
                                        code: "CS-SME-A", name: 'Política de salud', allowEdit:false
                                    },
                                    {
                                        code: "CS-SME-B", name: 'Sistema de Registro', allowEdit:false,
                                        children: [
                                            {
                                                code: "CS-SME-B1", name: 'Historia clínica única', allowEdit:true
                                            },
                                            {
                                                code: "CS-SME-B2", name: 'Accidentes, enfermedades e incapacidades', allowEdit:true
                                            },
                                            {
                                                code: "CS-SME-B3", name: 'Ausentismo', allowEdit:true
                                            },
                                            {
                                                code: "CS-SME-B4", name: 'Perfiles de morbilidad', allowEdit:true
                                            },
                                            {
                                                code: "CS-SME-B5", name: 'Investigación Científica', allowEdit:true
                                            },

                                        ],
                                    },
                                    {
                                        code: "CS-SME-C", name: 'Planes de emergencia y contingencia', allowEdit:false,
                                        children: [
                                            {
                                                code: "CS-SME-C1", name: 'Evaluación Médica (MEDEVAC)', allowEdit:true
                                            },
                                            {
                                                code: "CS-SME-C2", name: 'Planes de accidentes mayores', allowEdit:true
                                            },
                                            {
                                                code: "CS-SME-C3", name: 'Equipos de emergencia y medicamentos', allowEdit:true
                                            },
                                            {
                                                code: "CS-SME-C4", name: 'Simulacros', allowEdit:true
                                            },
                                        ],
                                    },

                                ],
                            }
                        ],
                    },
                    {
                        code: "CT", name: 'CONDICIONES DE TRABAJO', allowEdit:false,
                        children: [
                            {
                                code: "CT-A", name: 'Estudios de seguridad e higiene', allowEdit:false,
                                children: [
                                    {
                                        code: "CT-A1", name: 'Del servicio médico', allowEdit:true
                                    },
                                    {
                                        code: "CT-A2", name: 'Del comedor y cocina', allowEdit:true
                                    },
                                    {
                                        code: "CT-A3", name: 'Del sistena de agua', allowEdit:true
                                    },
                                    {
                                        code: "CT-A4", name: 'Otras', allowEdit:true
                                    },
                                ],
                            },
                            {
                                code: "CT-B", name: 'Procesos de trabajo', allowEdit:false,
                                children: [
                                    {
                                        code: "CT-B1", name: 'Objeto / Sujeto', allowEdit:true
                                    },
                                    {
                                        code: "CT-B2", name: 'Medios', allowEdit:true
                                    },
                                    {
                                        code: "CT-B3", name: 'Actividad', allowEdit:true
                                    },
                                    {
                                        code: "CT-B4", name: 'Organización y División del trabajo', allowEdit:true
                                    },
                                ],
                            },
                            {
                                code: "CT-C", name: 'Procesos peligrosos', allowEdit:false,
                                children: [
                                    {
                                        code: "CT-C1", name: 'Exploración Sensorial', allowEdit:true
                                    },
                                    {
                                        code: "CT-C2", name: 'Valoración Instrumental', allowEdit:true
                                    },
                                    {
                                        code: "CT-C3", name: 'Controles operativos y medidas de protección personal y colectiva', allowEdit:true
                                    },
                                    {
                                        code: "CT-C4", name: 'Monitoreo de los procesos peligrosos y de las medidas de intervención (eventos centinela)', allowEdit:true
                                    },
                                ],
                            },
                            {
                                code: "CT-D", name: 'Procesos positivos', allowEdit:false,
                                children: [
                                    {
                                        code: "CT-D1", name: 'Del puesto de trabajo', allowEdit:true
                                    },
                                    {
                                        code: "CT-D2", name: 'Del centro laboral', allowEdit:true
                                    },
                                ],
                            }
                        ],
                    },
                    {
                        code: "VEXT", name: 'VIDA EXTRA LABORAL', allowEdit:false,
                        children: [
                            {
                                code: "VEXT-A", name: 'Trabajo doméstico', allowEdit:true
                            },
                            {
                                code: "VEXT-B", name: 'Consumo simple y ampliado', allowEdit:true
                            },
                            {
                                code: "VEXT-C", name: 'Uso del tiempo libre', allowEdit:true
                            },
                        ],
                    },
                    {
                        code: "HCU", name: 'HISTORIA CLÍNICA ÚNICA', allowEdit:false
                    },
                ],
                questions: ["ACTIVIDAD","CONTRATISTA","DÍAS PERDIDOS", "HORAS CAPACITACIÓN","NUMERO DE ASISTENTES","PACIENTE","PUESTO DE TRABAJO","TEMA","TIPO DE PROGRAMA","TIPO DE VACUNA","TIPO DE PROCESOS PELIGROSOS"],
                selectQuestions: [],
                tree: [],
                itemTree:""
            };
        },

        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.catalog = new Catalog();
                this.catalogParent = new Catalog();
                this.valid = false;
                this.dialog = false;
            },
            newCatalog() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
            },
            saveData() {
                if (this.$refs.form.validate()) {
                  if(this.itemTree.months=="" || this.itemTree.months==[] || this.itemTree.months==null){
                    this.itemTree.months = ""
                  }else{
                    this.itemTree.months = JSON.stringify(this.itemTree.months)
                  }
                  if(this.itemTree.questions=="" || this.itemTree.questions==[]|| this.itemTree.questions==null){
                    this.itemTree.questions = ""
                  }else{
                    this.itemTree.questions = JSON.stringify(this.itemTree.questions)
                  }
                  if(this.itemTree.frequency=="" || this.itemTree.frequency==[]|| this.itemTree.frequency==null){
                    this.itemTree.frequency = ""
                  }
                  if(this.itemTree.trimester=="" || this.itemTree.trimester==[]|| this.itemTree.trimester==null){
                    this.itemTree.trimester = ""
                  }else{
                    this.itemTree.trimester = JSON.stringify(this.itemTree.trimester)
                  }
                  if (this.itemTree.id == "") {
                        this.$store.dispatch('addActivityConfiguration', this.itemTree).then(
                            response => {
                              this.itemTree.id = response.data.id
                              this.itemTree.months = JSON.parse(this.itemTree.months)
                              this.itemTree.questions = JSON.parse(this.itemTree.questions)
                              this.itemTree.trimester = JSON.parse(this.itemTree.trimester)
                              this.getParents()
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    } else {
                        this.$store.dispatch('updateActivityConfiguration', this.itemTree).then(
                            response => {
                              this.itemTree.id = response.data.id
                              this.itemTree.months = JSON.parse(this.itemTree.months)
                              this.itemTree.questions = JSON.parse(this.itemTree.questions)
                              this.itemTree.trimester = JSON.parse(this.itemTree.trimester)
                              this.getParents()
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    }
                    this.dialog = false;
                }
            },
            editItem(item) {
                this.itemTree = item
                this.dialog = true
            },
            addItem(item) {
              this.itemTree = {
                id:"",
                name:"",
                allowEdit:true,
                months:"",
                frequency:"",
                trimester:"",
                activityConfiguration: {id:item.id},
                children:[]
              }
              this.dialog = true

            },

          async deleteItem(item) {
             if (confirm('Está seguro de que quiere eliminar el registro?')) {
               await  this.$store.dispatch('deleteActivityConfiguration', item.id).then(
                      response => {
                        this.getParents()
                      },
                      error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                      }
                  );
                }
            },

           async getChildren(item){
             await this.$store.dispatch('getActivityConfigurationsByFather',item.id).then(
                  response => {
                    for (const data of response.data) {
                      if(data.months!=null && data.months!= ''){
                        data.months = JSON.parse(data.months)
                      }
                      if(data.questions!=null && data.questions!= ''){
                        data.questions = JSON.parse(data.questions)
                      }
                      if(data.trimester!=null && data.trimester!= ''){
                        data.trimester = JSON.parse(data.trimester)
                      }
                      console.log(data)

                      data.children = []
                      item.children.push(data)
                    }
                  },
                  error => {
                    this.$store.state.dialogError = true;
                  }
              );
            },
          getParents() {
            this.active = []
            this.open = []
            this.tree= []
            this.itemsTree = []
            this.$store.dispatch('getActivityConfigurations').then(
                response => {
                  for (const item of response.data) {
                    item.children = []
                    this.itemsTree.push(item)
                  }
                },
                error => {
                  this.$store.state.dialogError = true;
                }
            );
          }
        },
        computed: {
          filter() {
            return this.search
                ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                : undefined
          },
        },
      created() {
       this.getParents()

      },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/activity/ActivityConfiguration.vue